import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DestroyRef, inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  GuardResult,
  MaybeAsync,
  RouterStateSnapshot
} from '@angular/router';
import { map } from 'rxjs';
import { AuthorizationService } from '~ngx-shared/authentication';
import { UserService } from '~shared/services';
import { RoleEnum } from '~shared/utils';

@Injectable({ providedIn: 'root' })
export class CanAccessPersonDetailGuard implements CanActivate {
  private readonly destroyRef = inject(DestroyRef);
  private readonly userService = inject(UserService);
  private readonly authorizationService = inject(AuthorizationService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
    if (this.authorizationService.can(RoleEnum.MODERATOR)) {
      return true;
    }

    if (this.authorizationService.can(RoleEnum.COMMUNITY_OFFICE)) {
      return this.userService.user$.pipe(
        takeUntilDestroyed(this.destroyRef),
        map(user => {
          return !!user?.current_person_data?.can_sign;
        })
      );
    }

    return false;
  }
}
